<template>
  <div class="mt-8">
    <px-view-module-header module-name="Cotações" :breadcrumbs="breadcrumbs"/>
    <px-view-header-title class="mt-8" title="Solicitação de cotação">
      <template v-slot:before>
        <v-btn class="mb-1 mr-1" icon x-large color="primary" link @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header-title>
    <div v-if="loading" class="text-center">
      <px-circular-loading />
    </div>
    <div v-if="!loading && solicitacao" class="mt-5">
      <div>
        <px-card-solicitacao-dados-basicos :solicitacao="solicitacao"
                                           :id-solicitacao="id"
                                           @movimentar="onMovimentar"/>
      </div>
    </div>
    <div id="negociacoes">
      <px-negociacao v-if="!loading && isRespondida"
                     :resposta="solicitacao.respostaCotacao"
                     :cotacao-id="id"/>
    </div>
  </div>
</template>

<script>
import { SituacaoRespostaCotacaoProduto } from 'px-business-components';
import Negociacao from '@/modules/cotacoes/negociacao/Negociacao.vue';
import eventsMixin from '@/mixins/events-mixin';
import CardSolicitacaoDadosBasicos from './CardSolicitacaoDadosBasicos.vue';
import SolicitacaoService from './solicitacao-service';

export default {
  mixins: [eventsMixin],
  data() {
    return {
      loading: false,
      id: this.$route.params.id,
      solicitacao: null,
      breadcrumbs: [
        { text: 'Negócios' },
        { text: 'Cotações' },
      ],
    };
  },
  computed: {
    isRespondida() {
      return this.solicitacao && this.solicitacao.situacaoSolicitacaoResposta
        === SituacaoRespostaCotacaoProduto.keys.RESPONDIDA.key;
    },
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.cotacoes' });
    },
    getSolicitacao() {
      return SolicitacaoService.getSolicitacao(this.id)
        .then((response) => {
          this.solicitacao = response.data;
        });
    },
    onMovimentar() {
      this.getSolicitacao();
    },
  },
  created() {
    this.getSolicitacao();
    this.createEventAccessTarget(this.eventsResource.COTACAO, { solicitacao: this.id }, this.id);
  },
  components: {
    pxCardSolicitacaoDadosBasicos: CardSolicitacaoDadosBasicos,
    pxNegociacao: Negociacao,
  },
};
</script>
